import { render, staticRenderFns } from "./PersonalLeaveEntitlementTable.vue?vue&type=template&id=88cbd634&scoped=true&"
import script from "./PersonalLeaveEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./PersonalLeaveEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cbd634",
  null
  
)

export default component.exports